import Service from '../../services/ResellersService';
import RequestList from "../../services/RequestList";

const state = {
    sentRequestCount: 0,
    items : [],
    resellers: {}
}

const getters = {
    fetching(state) {
        return state.sentRequestCount > 0;
    }
}

const mutations = {
    SET_ITEMS(state, items) {
        let keyedByPrimaryKey = {};

        items.forEach(item => {
            keyedByPrimaryKey[item.id] = item;
        });

        state.resellers = keyedByPrimaryKey;
        state.items = items;
    },
    INCREMENT_SENT_REQUEST_COUNT(state) {
        state.sentRequestCount++;
    },
    DECREMENT_SENT_REQUEST_COUNT(state) {
        state.sentRequestCount--;
    }
}

const actions = {
    async sync({ commit }) {
        commit('INCREMENT_SENT_REQUEST_COUNT');

        try {
            let requestList = new RequestList();
            let {
                data
            } = await Service.list(requestList);
            commit('SET_ITEMS', data.value.resellers);
        } finally {
            commit('DECREMENT_SENT_REQUEST_COUNT');
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}